'use client'

import useAppInit from '@/hooks/business/useAppInit'

export default function AppInit() {
  useAppInit()
  return null
}
